<template>
  <WidgetCadre
    titre="Nouveautés"
    v-bind="apparence"
    :reglable="reglable"
    @retirer="$emit('retirer')"
  >
    <template #indice>
      <span class="nouveautes__version">v{{ APP_VERSION }}</span>
    </template>

    <ol class="nouveautes">
      <li
        v-for="(release, index) in dernieres"
        :key="release.version"
      >
        <button
          class="nouveaute surface"
          type="button"
          @click="ouvrir(index)"
        >
          <span class="nouveaute__titre">{{ release.title }}</span>
          <span class="nouveaute__quand">{{ dateCourte(release.date) }}</span>
        </button>
      </li>
    </ol>

    <ReleaseNotesDialog
      v-model="dialogueOuvert"
      :releases="aPartirDe"
      scope="internal"
    />
  </WidgetCadre>
</template>

<script setup>
import { computed, ref } from 'vue'
import ReleaseNotesDialog from '@/components/ReleaseNotes/ReleaseNotesDialog.vue'
import { APP_VERSION, releases } from '@/config/releases'
import WidgetCadre from './WidgetCadre.vue'
import { apparenceDe } from './apparence'

/**
 * Les dernières versions livrées, lues dans le bundle : rien à demander au
 * serveur, les notes voyagent déjà avec l'application.
 *
 * Réservé à l'accueil interne, d'où le périmètre `internal` sans filtrage :
 * un client extranet n'a pas cet écran.
 */

defineProps({
    donnees: { type: [Object, Array], default: null },
    chargement: { type: Boolean, default: false },
    panne: { type: Boolean, default: false },
    reglable: { type: Boolean, default: false },
})

defineEmits(['retirer', 'recharger'])

const apparence = apparenceDe('nouveautes')

const LIGNES = 5

const dernieres = releases.slice(0, LIGNES)

const dialogueOuvert = ref(false)
const depart = ref(0)

/** Le dialogue ouvre sur la version cliquée, et permet de remonter vers les plus anciennes. */
const aPartirDe = computed(() => releases.slice(depart.value))

function ouvrir(index) {
    depart.value = index
    dialogueOuvert.value = true
}

function dateCourte(iso) {
    return new Date(iso).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })
}
</script>

<style lang="scss" scoped>
.nouveautes {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin: 0;
  padding: 0;
  list-style: none;

  &__version {
    font-size: 11.5px;
    font-weight: 600;
    color: var(--encre);
    font-variant-numeric: tabular-nums;
  }
}

.nouveaute {
  display: flex;
  align-items: baseline;
  gap: 10px;
  width: 100%;
  padding: 8px 10px;
  border: none;
  cursor: pointer;
  text-align: left;


  /* Un filet entre les lignes plutôt qu'un aplat par ligne : la liste se lit
     d'un trait, et le survol seul désigne ce qui est cliquable. En bordure et
     non en ombre portée : l'ombre servirait le même canal que le repère « en
     retard », et l'effacerait sur toute ligne qui en suit une autre. */
  & + & { border-top: 1px solid var(--el-border-color-lighter); }

  &:focus-visible {
    outline: 2px solid var(--accent);
    outline-offset: 1px;
  }

  &__titre {
    flex: 1;
    min-width: 0;
    font-size: 13px;
    line-height: 1.35;
    color: var(--el-text-color-primary);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__quand {
    font-size: 11.5px;
    color: var(--el-text-color-secondary);
    flex-shrink: 0;
  }
}
</style>
